import './style.less';

export default function($state, $stateParams, $location, ResolveClass, store) {
  'ngInject';

  const vm = this;

  vm.$onInit = activate;

  vm.setCollapse = () => {
    vm.collapse = !vm.collapse;
    store.set('cpeCatalogCollapse', vm.collapse);
  };

  function getCollapse() {
    const storedValue = store.get('cpeCatalogCollapse');
    return storedValue == null ? ResolveClass.applicationSettings('mktCatalog').collapse : !!storedValue;
  }

  function setView(newView) {
    const currentView = newView || vm.defaultView || $stateParams.view || store.get('cpeCatalogView') || 'table';
    let view = 'table';

    if (currentView === 'calendar') {
      view = 'calendar';
    }

    if (currentView === 'card') {
      view = 'card';
    }

    $location.search('view', view);
    store.set('cpeCatalogView', view);
    vm.view = view;
  }

  vm.setView = setView;

  function getPageTitle() {
    return ResolveClass.applicationSettings('mktCatalog').name || 'All Courses';
  }

  function activate() {
    vm.collapse = getCollapse();
    vm.pageTitle = getPageTitle();
    vm.nameSearch = $stateParams.name;
    vm.state = vm.stateOverride || $state.current.name;

    setView();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/cpeCatalog/base/controller.js